import { auth } from '../lib/Firebase-config';

export async function buildAuthHeaders(extraHeaders = {}, options = {}) {
    const headers = { ...extraHeaders };
    const currentUser = auth.currentUser;

    if (!currentUser?.getIdToken) {
        return headers;
    }

    try {
        const token = await currentUser.getIdToken(options.forceRefresh === true);
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
    } catch (error) {
        console.warn('Unable to attach auth token:', error.message);
    }

    return headers;
}
